import { connect } from "react-redux";
import UnitValue from "./UnitValue";

export default connect(state => ({
	units: state.units
}))(UnitValue);
